import { request } from '@/utils/request';

export const getGames = () => {
  return request({
    url: '/hall/get_game_layout',
    method: 'post',
    data: {
      configname: 'game_config/game_map_230314.json'
    }
  });
};

/**
 * 获取配置
 * @returns
 */
export const get_awardconfig = () => {
  return request({
    url: '/gamer/get_awardconfig'
  });
};

/* 判断是否需要绑定手机号 */
export const need_bind_phone = () => {
  return request({
    url: '/hall/get_bind_phone_list'
  });
};

/**
 * 获取充值视图优化开关
 * @returns
 */
export const recharge_view_better = () => {
  return request({
    url: '/hall/firstpay_mvp'
  });
};
/**
 * 每日签到 */
export const query_user_daygold_v2 = () => {
  return request({
    url: '/hall/query_user_daygold_v2_pe',
    method: 'post'
  });
};

export const take_daygold_v2 = () => {
  return request({
    url: '/hall/take_daygold_v2_pe',
    method: 'post'
  });
};

// 领取奖励
export const day_cz_take_allreward = () => {
  return request({
    url: '/api/hall/day_cz_take_allreward',
    method: 'post'
  });
};

/** 获取客服机器人开关
 * 1 为开，0 为关
 * @deprecated
 */
export const getChatRobotFlag = () =>
  request({
    url: `/api/hall/get_aiservice_flag?product=${__PRODUCT_NAME__ || ''}`
  });

/** 获取VIP客服弹窗开关
 * 1 为打开过，0 为默认
 */
export const getVipKefuFlag = () => {
  return request({
    url: '/hall/get_vip_ai_flag'
  });
};

/** 设置VIP客服弹窗为打开过
 *
 */
export const setVipKefuFlag = () => {
  return request({
    url: '/hall/set_vip_ai_flag'
  });
};
/** 获取客服的 tg 名称 */
export const getKefuName = product =>
  request({
    url: `/api/hall/get_aiservice_data?product=${product}`
  }).then(res => {
    try {
      return JSON.parse(res.data);
    } catch (error) {
      return {};
    }
  });
